import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=0c285b4b&scoped=true&"
import script from "./NewsletterModal.vue?vue&type=script&lang=js&"
export * from "./NewsletterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c285b4b",
  null
  
)

export default component.exports